import axios from "./../../config/axios";

function summary(date) {
    return axios().get("/sales-scheduling/summary", {
        params: {
            date
        }
    })
}

export default {
    summary
}